import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, Menu, X } from "lucide-react";
import { useState } from "react";
import { LOGO_URL } from "@/lib/api";
import { BackgroundMusicHeaderToggle } from "@/components/BackgroundMusicToggle";

const navLink = ({ isActive }) =>
  `text-sm uppercase tracking-[0.2em] font-outfit font-medium transition-colors ${
    isActive ? "text-hotpink" : "text-white/80 hover:text-hotpink"
  }`;

export default function Header() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const close = () => setOpen(false);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-ink/70 border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 md:px-10 py-3 md:py-4 flex items-center justify-between gap-3">
        <Link to="/" data-testid="logo-home" className="flex items-center gap-2 group flex-shrink-0">
          <img
            src={LOGO_URL}
            alt="If We Knew"
            className="h-14 sm:h-16 md:h-20 w-auto"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/" end className={navLink} data-testid="nav-home">Home</NavLink>
          <NavLink to="/episodes" className={navLink} data-testid="nav-episodes">Episodes</NavLink>
          <NavLink to="/about" className={navLink} data-testid="nav-about">About Joey</NavLink>
          <BackgroundMusicHeaderToggle />
          {user ? (
            <div className="flex items-center gap-4">
              {user.is_admin && (
                <NavLink to="/admin" className={navLink} data-testid="nav-admin">Admin</NavLink>
              )}
              <NavLink to="/profile" className={navLink} data-testid="nav-profile">My stash</NavLink>
              <span className="scribble text-hotpink text-xl hidden lg:inline" data-testid="nav-user-name">hi, {user.name}</span>
              <button onClick={() => { logout(); nav("/"); }} data-testid="nav-logout" className="text-white/70 hover:text-hotpink"><LogOut size={18}/></button>
            </div>
          ) : (
            <>
              <NavLink to="/login" className={navLink} data-testid="nav-login">Login</NavLink>
              <Link to="/signup" data-testid="nav-signup" className="bg-hotpink hover:bg-hotpink_dark text-white px-5 py-2 font-outfit font-bold uppercase tracking-wider text-xs shadow-[3px_3px_0px_#FFFFFF] hover:shadow-[5px_5px_0px_#FFFFFF] transition-all">
                Start listening
              </Link>
            </>
          )}
        </nav>

        <button onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" className="md:hidden text-white">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-ink px-5 py-4 flex flex-col gap-4" data-testid="mobile-menu">
          <NavLink to="/" end className={navLink} onClick={close}>Home</NavLink>
          <NavLink to="/episodes" className={navLink} onClick={close}>Episodes</NavLink>
          <NavLink to="/about" className={navLink} onClick={close}>About Joey</NavLink>
          {user?.is_admin && (
            <NavLink to="/admin" className={navLink} onClick={close} data-testid="mobile-nav-admin">Admin</NavLink>
          )}
          {user && (
            <NavLink to="/profile" className={navLink} onClick={close} data-testid="mobile-nav-profile">My stash</NavLink>
          )}
          {user ? (
            <button onClick={() => { logout(); nav("/"); close(); }} className="text-left text-white/80">Logout</button>
          ) : (
            <>
              <NavLink to="/login" className={navLink} onClick={close}>Login</NavLink>
              <NavLink to="/signup" className={navLink} onClick={close}>Sign up</NavLink>
            </>
          )}
        </div>
      )}
    </header>
  );
}
